/* v5: pionowe przerywniki: wejście clip-path (kadry kolejno) + lekki paralaks obrazu */
const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
const root = document.documentElement;
const clamp01 = (v) => Math.max(0, Math.min(1, v));
const frames = [...document.querySelectorAll('[data-trio] .trio-img')];
if (!reduced && frames.length) {
  root.classList.add('v5');
  let vh = innerHeight, ticking = false;
  const update = () => {
    ticking = false;
    for (const el of frames) {
      const r = el.getBoundingClientRect();
      if (r.bottom < -80 || r.top > vh + 80) continue;
      // poprawki 08.10: bez opóźnienia między kadrami, wszystkie trzy mają to samo wcięcie w każdej chwili
      const p = clamp01((vh - r.top) / (vh * 0.7));
      const e = 1 - Math.pow(1 - p, 3);
      el.style.setProperty('--cy', `${(12 * (1 - e)).toFixed(2)}%`);
      el.style.setProperty('--cx', `${(10 * (1 - e)).toFixed(2)}%`);
      const q = clamp01((vh - r.top) / (vh + r.height));
      el.firstElementChild.style.setProperty('--ty', `${((0.5 - q) * 40).toFixed(1)}px`);
    }
  };
  const req = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
  addEventListener('scroll', req, { passive: true });
  addEventListener('resize', () => { vh = innerHeight; req(); });
  document.querySelectorAll('[data-trio]').forEach((t) => t.addEventListener('scroll', req, { passive: true }));
  update();
}

/* will-change tylko wtedy, gdy sekcja z ruchem jest na ekranie */
{
  const live = new IntersectionObserver((es) => es.forEach((e) => e.target.classList.toggle('is-live', e.isIntersecting)), { rootMargin: '20% 0px' });
  document.querySelectorAll('[data-trio], .day, .bleed, .nums').forEach((el) => live.observe(el));
}
